import { useEffect, useState } from "react";
import { checkUserPermission } from "../components/Can/Can";
import { getMe } from "../graphql/auth";

export const checkIsPrimaryPayer = () => {
    const [passed, setPassed] = useState(false);
    const userData = getMe();
    const role = ["paying-user"];

    useEffect(() => {
        if (
            userData.data &&
            userData.data.me &&
            userData.data.me.billingPartyMembers
        ) {
            const isPayingUser = checkUserPermission(
                userData.data.me,
                role,
                undefined,
                {},
                false
            );
            const isPrimaryPayer =
                userData.data.me.billingPartyMembers[0] &&
                userData.data.me.billingPartyMembers[0].primary_paying_member;

            setPassed(isPayingUser && isPrimaryPayer);
        }
    }, [userData, role]);

    return passed;
};
